import { render, staticRenderFns } from "./ItemsBox.vue?vue&type=template&id=10c6a8ef&scoped=true&"
import script from "./ItemsBox.vue?vue&type=script&lang=js&"
export * from "./ItemsBox.vue?vue&type=script&lang=js&"
import style0 from "./ItemsBox.vue?vue&type=style&index=0&id=10c6a8ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c6a8ef",
  null
  
)

export default component.exports